export const useTariffActions = () => {
  const classRateTariff = () => {
    console.log('Rated');
  };

  const changeEffectiveDates = () => {
    console.log('Changed');
  };

  const exportTariff = () => {
    console.log('Exported');
  };

  const deleteTariff = () => {
    console.log('Deleted');
  };

  return {
    changeEffectiveDates,
    classRateTariff,
    deleteTariff,
    exportTariff,
  };
};
